import React from "react";
import { Modal as MelodiesModal } from "melodies-source/Modal";
import styled from "styled-components";
import { BtnProps, Button } from "melodies-source/Button";

interface Action extends Omit<BtnProps, "text" | "children"> {
  text: string;
}

type Actions = Record<"secondary" | "main", Action> & {
  tertiary?: Action;
};

export interface ModalProps extends React.ComponentProps<typeof MelodiesModal> {
  actions?: Actions;
  isForm?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  children,
  actions,
  isForm,
  ...props
}) => {
  const { text: secondaryButtonText, ...secondaryButtonProps } =
    actions?.secondary || {};
  const {
    text: mainButtonText,
    onClick: mainButtonOnClick,
    ...mainButtonProps
  } = actions?.main || {};
  const { text: tertiaryButtonText, ...tertiaryButtonProps } =
    actions?.tertiary || {};

  const content = (
    <>
      {children}
      {actions && (
        <ActionsContainer>
          {tertiaryButtonText && (
            <TertiaryButton {...tertiaryButtonProps} text>
              {tertiaryButtonText}
            </TertiaryButton>
          )}
          <Actions>
            <Button {...secondaryButtonProps} text>
              {secondaryButtonText}
            </Button>
            <Button
              {...mainButtonProps}
              variant={actions.main.variant || "primary"}
              {...(isForm
                ? { type: "submit" }
                : { onClick: mainButtonOnClick })}
            >
              {mainButtonText}
            </Button>
          </Actions>
        </ActionsContainer>
      )}
    </>
  );
  return (
    <MelodiesModal {...props}>
      {isForm ? <Form onSubmit={mainButtonOnClick}>{content}</Form> : content}
    </MelodiesModal>
  );
};

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 30px;

  ${({ theme }) => theme.media.mobile} {
    align-items: flex-start;
    flex-direction: column;
    gap: 15px;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column-reverse;
    width: 100%;

    button {
      width: 100%;
    }
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const TertiaryButton = styled(Button)`
  padding: 0;
  background-color: unset !important;
`;
